// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/:locale/careers\",\"regex\":\"^/([^/]+)/careers$\",\"paramNames\":[\"locale\"]},{\"path\":\"/:locale/careers/:slug\",\"regex\":\"^/([^/]+)/careers/([^/]+)$\",\"paramNames\":[\"locale\",\"slug\"]},{\"path\":\"/:locale\",\"regex\":\"^/([^/]+)$\",\"paramNames\":[\"locale\"]},{\"path\":\"/:locale/contact-us\",\"regex\":\"^/([^/]+)/contact-us$\",\"paramNames\":[\"locale\"]},{\"path\":\"/:locale/our-story\",\"regex\":\"^/([^/]+)/our-story$\",\"paramNames\":[\"locale\"]},{\"path\":\"/:locale/catalog/:type\",\"regex\":\"^/([^/]+)/catalog/([^/]+)$\",\"paramNames\":[\"locale\",\"type\"]},{\"path\":\"/:locale/product/:slug\",\"regex\":\"^/([^/]+)/product/([^/]+)$\",\"paramNames\":[\"locale\",\"slug\"]},{\"path\":\"/:locale/search\",\"regex\":\"^/([^/]+)/search$\",\"paramNames\":[\"locale\"]}],\"staticRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "15.5.7";import * as Sentry from "@sentry/nextjs";

Sentry.init({
  dsn: "https://13e4c419cbc1948df989defe4d8bdd04@o4510125015171072.ingest.de.sentry.io/4510125579763792",

  // Add optional integrations for additional features
  integrations: [
    Sentry.replayIntegration(),
  ],

  // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
  tracesSampleRate: 1,
  // Enable logs to be sent to Sentry
  enableLogs: true,

  // Define how likely Replay events are sampled.
  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.1,

  // Define how likely Replay events are sampled when an error occurs.
  replaysOnErrorSampleRate: 1.0,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;